import { useMutation, useQueryClient } from '@tanstack/react-query'
import { type ApiResponseError, fetchApiWithToken } from '~/api/utils'

export const useTempoSyncApplicant = () => {
  const queryClient = useQueryClient()

  return useMutation<{ success: boolean }, ApiResponseError, number>({
    mutationFn: (applicantId) =>
      fetchApiWithToken<{ success: boolean }>({
        method: 'post',
        url: `/v1/tempo/applicants/${applicantId}/sync`
      }),
    onSuccess: (_data, applicantId) => {
      queryClient.invalidateQueries({
        queryKey: ['tempo', 'applicant-sync-status', applicantId]
      })
    }
  })
}
